import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateSearchComponent } from "../../templates/template-search/template-search.component";
import { SelectOption } from "../../templates/template-select/template-select.component";

@Component({
  selector: "app-prefix-idj",
  imports: [TemplateSearchComponent],
  templateUrl: "./prefix-idj.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-idj.component.less",
})
export class PrefixIdjComponent extends PrefixComponent<string> {
  @Input()
  public options: SelectOption[];
  public multiple: boolean;

  public constructor() {
    super();
    this.options = [];
    this.multiple = false;
    this.characters = ALLOWED_CHARACTERS["idj"];
  }
}
